import { styled } from '@mui/material/styles';
import { Grid, Box, Typography } from '@mui/material';

// Theme-aware metric cards (primary for selected/active — works in blue + AI themes)
export const MetricGridContainerStyledComponent = styled(Grid)<any>(
  ({ theme, showPointer, active }: {theme: any; showPointer: boolean; active: boolean}) => ({
    cursor: showPointer ? 'pointer' : 'default',
    transition: 'all 0.3s ease',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0px 5px 24px -10px rgba(0, 0, 0, 0.1)',
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor:
      active && showPointer
        ? theme.palette.primary.main
        : theme.palette.background.paper,
    color:
      active && showPointer
        ? theme.palette.primary.contrastText
        : theme.palette.text.primary,
    '&:hover': showPointer && !active
      ? {
          boxShadow: '0px 5px 40px -10px rgba(0, 0, 0, 0.15)',
          transform: 'scale(1.03)',
          border: `1px solid ${theme.palette.primary.dark}`,
        }
      : {},
  })
);

export const MetricGraphBoxContainerStyledComponent = styled(Box)<any>(
  ({ theme, hasData }) => ({
    height: '100%',
    width: '100%',
    opacity: hasData ? 1 : 0.3,
  }),
);

export const MetricGridStyledComponent = styled(Grid)<any>(
  ({ theme, isSelected }) => ({
    color: isSelected
      ? theme.palette.primary.contrastText
      : 'inherit',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }),
);

export const MetricBoxContainerStyledComponent = styled(Box)<any>(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
  }),
);

export const MetricCountTypograpgyStyledComponent = styled(Typography)<any>(
  ({ theme }) => ({
    fontWeight: 'bold',
    lineHeight: 1,
    color: 'inherit',
  }),
);

export const MetricLabelTypograpgyStyledComponent = styled(Typography)<any>(
  ({ theme }) => ({
    lineHeight: 1.1,
    mb: 2,
    textAlign: 'center',
    textWrap: 'nowrap',
    color: 'inherit',
  }),
);
